export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9468.02e04091.jpg";